import { render } from "./IconMail.vue?vue&type=template&id=aa3f32a8"
import script from "./IconMail.vue?vue&type=script&lang=js"
export * from "./IconMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__